const COMPONENT_NAME = "z-view" ;

import routes from "../../util/routes.js";

export default function register(){
    class FieldDefaultComponent extends HTMLElement {
        constructor() {
            super();
            this.renderId = 0;
        }

        prepareController(path){
            const route = routes.find(r => r.regexp.exec(path)) ;
            if(!route){
                this.viewController = null;
                return;
            }
            this.viewController = route.viewControllerGenerator() ;
            this.viewController.screen = route.screen;
            const params = {};
            const list = route.regexp.exec(path).slice(1);
            route.keys.forEach((v, i) => {
                params[v.name] = list[i];
            });
            this.params = params;
        }
        
        renderView(path = null){
            if(!path){
                path = this.getAttribute("z-path") ;
            }
            
            this.prepareController(path) ;
            if(!this.viewController){
                this.innerHTML = "" ;
                return;
            }

            this.renderId++;
            let renderId = this.renderId ;
            this.viewController.embedded = true;
            return this.viewController.prepareView().then(()=>{
                if(renderId === this.renderId && this.viewController){
                    return this.viewController.renderView(this, {params: this.params}) ;
                }
            });
        }

        static get observedAttributes() {
            return ["z-path"];
        }

        attributeChangedCallback(name, oldValue, newValue) {
            switch (name) {
                case 'z-path':
                    this.renderView() ;
                    break;
               
            }
        }
        
    }
    customElements.define(COMPONENT_NAME, FieldDefaultComponent);
}
